import {
  getFilterHistoryModel,
  getFilterHistoryStorageModel,
  getSearchAccordionOpenSettingModel,
} from '@/features/search/_utils/local-storage';
import { z } from 'zod';

export const CommentSearchAccordionOpenSettingValueModel = z.object({
  comment: z.boolean(),
});
export const CommentSearchAccordionOpenSettingModel =
  getSearchAccordionOpenSettingModel(
    CommentSearchAccordionOpenSettingValueModel,
  );

const CommentFilterHistoryModel = getFilterHistoryModel();
export const CommentFilterHistoryStorageModel = getFilterHistoryStorageModel(
  CommentFilterHistoryModel,
);
